import React, { useEffect, useState } from 'react';
import { isEmpty } from "lodash"
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';
import { Box, Grid, Button } from '@material-ui/core';

const FormReturnSale = (props) => {

    const createShopList = () => {
        const list = []
        const { SHOPS, OCCASION } = props
        if( !isEmpty(OCCASION) ){
            let shopList = []
            Object.values(OCCASION).forEach( stock => {
                if (!shopList.includes(stock.shop_id) && stock.quantity > 0){
                    shopList.push(stock.shop_id)
                }
            })
            
            shopList.map( ID => { 
                let shop = SHOPS[ID]
                let selected = !!shop.shop_disabled
                if(props.sale.shop ===  ID) {  // already selected   
                    selected = true 
                } 
                list.push (       
                    {value: ID, label:shop.name, disabled:selected} 
                )
            })
        }
        return list
    }
        const shops = createShopList()
        return (
            <div className="card-text">
                <h3 className="card-title">Nouvelle Vente occasion</h3>
                <Box p={2}>
                    <InputSelectMagasin
                        options={[
                            {value:"payg", label:"Pay As You Go"},
                            {value:"vente", label:"Vente"},
                            {value:"transfer", label:"Transfert de stock"},
                        ]}
                        value={props.sale.natureDisplay}
                        label="Nature"
                        onChange={option => props.handleSelect(option,"nature")}
                        // isOptionDisabled={option => option.disabled === true}
                        error={props.errors.nature}
                    /> 

                   

                    {props.sale.nature === "payg" && 
                        <InputSelectMagasin
                            options={[
                                {value:"mjb", label:"Plateforme MyJouleBox"},
                                {value:"other", label:"Autre plateforme"},
                            ]}
                            value={props.sale.cli_typeDisplay}
                            onChange={option => props.handleSelect(option,"cli_type")}
                            // isOptionDisabled={option => option.disabled === true}
                            error={props.errors.cli_type}
                            label="Type Client"
                        /> 
                    }
                    
                    {props.sale.nature !== "" && 
                        <InputSelectMagasin
                            options={shops}
                            value={props.sale.shopDisplay}
                            onChange={option => props.handleSelect(option,"shop")}
                            // isOptionDisabled={option => option.disabled === true}
                            error={props.errors.shop}
                            label="Magasin"
                        /> 
                    }
                    {props.sale.nature === "transfer" && 
                        <InputSelectMagasin
                            options={shops}
                            value={props.sale.shopDestDisplay}
                            onChange={option => props.handleSelect(option,"shopDest")}
                            // isOptionDisabled={option => option.disabled === true}
                            error={props.errors.shopDest}
                            label="Magasin Destinataire"
                        /> 
                    }
                    <div>
                        {/* <FormLayout title={"Produits"}>
                            {props.createAddForm()}
                            <TableRow className="plus-btn" onClick={props.handleAddProd}>
                                <TableCell colSpan={4}>
                                    <a> 
                                        <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw"></i>
                                        <span>Ajouter un produit</span> 
                                    </a>
                                </TableCell>
                            
                            </TableRow>
                        </FormLayout> */}
                        <FormLayout 
                            title={"Produits"}
                            rea={props.sale.nature === "transfer"}
                            createAddForm={props.createAddForm}
                            onClick={props.handleAddProd}
                            colSpan={4}
                        /> 
                    </div>
                    <InputText 
                        change={props.handleChange} 
                        value={props.sale.comments} 
                        name="comments" 
                        title="Commentaire" 
                        error={props.errors.comments} 
                    />
                    <Box p={2} />
                    <Grid container spacing={2}>
                        <Grid sm={6}></Grid>
                        <Grid sm={6} xs={12}>
                            <InputText 
                                change={props.handleChange} 
                                value={props.sale.discount} 
                                name="discount" 
                                title="Reduction" 
                                error={props.errors.discount} 
                                disabled 
                            />
                        
                            <InputText 
                                change={props.handleChange} 
                                value={props.sale.total} 
                                name="total" 
                                title="Total" 
                                error={props.errors.total} 
                                disabled 
                            />
                        </Grid>
                    </Grid>
                    
                <Box p={2}>
                    
                    <div className="pull-right">
                        <Button color="secondary" variant="contained" onClick={props.validate}>Valider</Button>
                        <Button color="secondary" onClick={props.handleClose}>Annuler</Button>
                    </div>

                </Box>
            </Box>
        </div>
        );
}

export default FormReturnSale;